import { useState } from "react";

interface Props {
  value: number;
  onChange: (value: number) => void;
  size?: number;
}

export function StarInput({ value, onChange, size = 28 }: Props) {
  const [hover, setHover] = useState(0);
  const display = hover || value;

  return (
    <div className="flex gap-1" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          onMouseEnter={() => setHover(n)}
          className="transition-transform hover:scale-110"
          style={{ fontSize: size, lineHeight: 1 }}
        >
          <span className={n <= display ? "text-warning" : "text-copy-subtle"}>★</span>
        </button>
      ))}
    </div>
  );
}
